module.exports = __webpack_public_path__ + "static/img/1.030b4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R134A/1.jpg
// module id = e2Cw
// module chunks = 1